import { SupportedLanguage } from '@app/utils/constants/supported-languages';

// Languages whose dates are typed DD-MM-YYYY in the datepickers; every other language types YYYY-MM-DD.
export const DAY_FIRST_DATE_LANGUAGES: readonly string[] = [
  SupportedLanguage.Es,
  SupportedLanguage.Pt,
  SupportedLanguage.Id,
  SupportedLanguage.Vi,
  SupportedLanguage.Th,
];
